// extracted by mini-css-extract-plugin
export default {"root":"About_root__JxWLK","subHeading":"About_subHeading__02f7R","list":"About_list__xrHJn","threeMoto":"About_threeMoto__kXI4q","threeMotoCard":"About_threeMotoCard__MViAV"};